    import React, { useState } from 'react';
import { Modal, Box, Button, List, ListItem, ListItemText, Typography } from '@mui/material';
import ShopifyConnectionForm from '../Forms/ShopifyConnectionForm';

interface ConnectionModalProps {
  open: boolean;
  onClose: () => void;
  onAddConnection: (connection: string) => void;
}

const ConnectionsModal: React.FC<ConnectionModalProps> = ({ open, onClose, onAddConnection }) => {
  const [showShopifyForm, setShowShopifyForm] = useState<boolean>(false);

  const handleShopifySubmit = (shopDomain: string) => {
    onAddConnection(`Shopify: ${shopDomain}`);
    setShowShopifyForm(false);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...modalStyle }}>
        {showShopifyForm ? (
          <ShopifyConnectionForm onSubmit={handleShopifySubmit} onCancel={() => setShowShopifyForm(false)} />
        ) : (
          <Box>
            <Typography variant="h6">Add a new connection</Typography>
            <List>
              <ListItem button onClick={() => setShowShopifyForm(true)}>
                <ListItemText primary="Shopify" />
              </ListItem>
            </List>
            <Button variant="contained" onClick={onClose}>
              Cancel
            </Button>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export default ConnectionsModal;
